export default __webpack_public_path__ + "static/media/report.e65080ff.svg";